import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AddressComponent } from 'src/app/shared/address/address.component';
import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Address } from '../../models/address.model';

@Component({
  selector: 'student-address',
  templateUrl: './student-address.component.html',
})
export class StudentAddressComponent {
  @ViewChild(AddressComponent) addressComponent: AddressComponent;

  title = this.store.state.isStaff ? 'studentAddress.titleStaff' : 'studentAddress.titleParent';
  progressBar = this.progress.studentAddress;
  address: Address = this.store.state.consent.student.address;
  states: Array<string> = ['KY', 'IN'];

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  disabled(): boolean {
    return this.addressComponent.form.valid;
  }

  back() {
    this.router.navigate([this.navigation.studentAddress.back]);
  }

  next() {
    this.store.state.consent.student.address = this.address;
    this.router.navigate([this.navigation.studentAddress.next]);
  }
}
